import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Icon } from '@mui/material'
import { StateBoxContainer, FlexBetween } from './style'
import CountUp from 'react-countup'

// ==============================|| DASHBOARD - DEFAULT ||============================== //

const DashboardIconBox = ({ bgColor, title, count, icon, iconColor, footerText, symbol, playerBalanceData, decimal = 2 }) => {
  return (
    <StateBoxContainer bgColorVal={bgColor}>
      <Box className='dashboard-stats-common'>
        <div className='stats-icon'>
          <Icon fontSize='medium' color='inherit' style={{ color: iconColor }}>
            {icon}
          </Icon>
        </div>
        {!playerBalanceData ?


          <div className='state-text-wrap'>
            <Typography className='state-text-head'>
              {title}
            </Typography>
            <Typography variant='h4' className='state-text-head'>
              <CountUp
                end={Number(count) || 0}
                duration={5} // seconds
                separator="," // adds thousand separator
                decimals={decimal}
              />{symbol && (<span>{symbol}</span>)}
            </Typography>





          </div>
          :

          <>

            <div className='state-text-wrap'>
              <Typography className='state-text-head '>
                {title}
              </Typography>
              <Typography variant='h4' className='state-text-head'>
                <CountUp
                  end={Number(count) || 0}
                  duration={5} // seconds
                  separator="," // adds thousand separator
                  decimals={decimal}
                />{symbol && (<span>{symbol}</span>)}
              </Typography>





            </div>

            <div className='state-text-wrap mt-1'>
              {Object.entries(playerBalanceData || {}).map(([key, value], index) => (
                <FlexBetween key={key}>
                  <Typography className={`state-text-sub-head`}>
                    {value?.title}
                  </Typography>

                  <Typography variant='h5' className='state-text-sub-head'>
                    <CountUp
                      end={Number(value?.amount) || 0}
                      duration={5}
                      separator=","
                      decimals={decimal}
                    />
                  </Typography>
                </FlexBetween>
              ))}
            </div>


          </>}



      </Box>

      {footerText && (
        <Typography className='stats-footer-text'>{footerText}</Typography>
      )}
    </StateBoxContainer>
  )
}

DashboardIconBox.propTypes = {
  bgColor: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node,
  iconColor: PropTypes.string,
  footerText: PropTypes.string
}

export default DashboardIconBox
